import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import ValidatorService from 'src/services/validation/Validation.service';
import Person from 'src/entities/Person';

export interface RequestDueDiligenceAttempt extends Action {
  type: Types.REQUEST_DUE_DILIGENCE_ATTEMPT;
}

export interface RequestDueDiligenceSuccess extends Action {
  type: Types.REQUEST_DUE_DILIGENCE_SUCCESS;
}

export interface RequestDueDiligenceFailure extends Action {
  type: Types.REQUEST_DUE_DILIGENCE_FAILURE;
  payload: {};
}

export type RequestDueDiligenceAction = RequestDueDiligenceAttempt |
  RequestDueDiligenceSuccess |
  RequestDueDiligenceFailure;

export interface RequestDueDiligenceThunk extends ThunkAction<Promise<RequestDueDiligenceAction>, RootState, null> {
}

export const requestDueDiligenceAttempt: ActionCreator<RequestDueDiligenceAttempt> = () => (
  {
    type: Types.REQUEST_DUE_DILIGENCE_ATTEMPT,
  }
);

export const requestDueDiligenceSuccess: ActionCreator<RequestDueDiligenceSuccess> = () => (
  {
    type: Types.REQUEST_DUE_DILIGENCE_SUCCESS,
  }
);

export const requestDueDiligenceFailure: ActionCreator<RequestDueDiligenceFailure> = (error: {}) => (
  {
    type: Types.REQUEST_DUE_DILIGENCE_FAILURE,
    payload: error,
  }
);

export const requestDueDiligence: ActionCreator<RequestDueDiligenceThunk> = (
  projectId: number, person: Person
): RequestDueDiligenceThunk => {

  return (dispatch: Dispatch<RootState>): Promise<RequestDueDiligenceAction> => {
    dispatch(requestDueDiligenceAttempt());

    return ApiClient.projectDueDiligence.update(projectId, {personId: person.id, personType: person.personType})
      .then((): RequestDueDiligenceSuccess => {
        return dispatch(requestDueDiligenceSuccess());
      }).catch((e: { response: { data: { error: {} } } }): RequestDueDiligenceFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);
        return dispatch(requestDueDiligenceFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/project/due-diligence/RequestDueDiligence.actions.tsx